import React from 'react'
import { Link } from 'react-router';
import Header from '../Header';
import Sidebar from '../Sidebar';

export default function EditUser() {
         const handleSubmit = (e) => {
    e.preventDefault();
  };

  return (
  <div id="dashboard-root" 
                className="flex min-h-[1000px] w-full">
                  {/* <!-- Sidebar --> */}
                  <Sidebar />
                  {/* <!-- Main Content --> */}
                  <main id="main-content" className="flex-1 px-10 py-8">
                    {/* <!-- Header --> */}
            <Header title="Edit User" />
            <form onSubmit={handleSubmit}>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6 p-8 bg-white">
                    <div>
                            <label className="block text-sm font-medium text-gray-700 mb-1">First Name</label>
                            <input type="text" value="John" className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-primary-500" />
                        </div>
                        <div>
                            <label className="block text-sm font-medium text-gray-700 mb-1">Last Name</label>
                            <input type="text" value="Smith" className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-primary-500" />
                        </div>
                        <div>
                            <label className="block text-sm font-medium text-gray-700 mb-1">Email Address</label>
                            <input type="email" value="john.smith@mediadmin.com" className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-primary-500" />
                        </div>
                        <div>
                            <label className="block text-sm font-medium text-gray-700 mb-1">Phone Number</label>
                            <input type="tel" value="(555) 123-4567" className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-primary-500" />
                        </div>
                        <div>
                            <label className="block text-sm font-medium text-gray-700 mb-1">Role</label>
                            <select className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-primary-500">
                                <option selected="">Administrator</option>
                                <option>Doctor</option>
                                <option>Nurse</option>
                                <option>Pharmacist</option>
                                <option>Inventory Manager</option>
                                <option>Staff</option>
                            </select>
                        </div>
                        <div>
                            <label className="block text-sm font-medium text-gray-700 mb-1">Department</label>
                            <select className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-primary-500">
                                <option selected="">Cardiology</option>
                                <option>Neurology</option>
                                <option>Pharmacy</option>
                                <option>Emergency</option>
                                <option>Logistics</option>
                                <option>Administration</option>
                            </select>
                        </div>
                        <div>
                            <label className="block text-sm font-medium text-gray-700 mb-1">Status</label>
                            <select className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-primary-500">
                                <option selected="">Active</option>
                                <option>Inactive</option>
                                <option>Suspended</option>
                            </select>
                        </div>
                        <div>
                            <label className="block text-sm font-medium text-gray-700 mb-1">User ID</label>
                            <input type="text" value="USR-1001" className="w-full border border-gray-300 rounded-lg px-3 py-2 bg-gray-100" readOnly="" />
                        </div>
                    </div>
                    <div className="mb-6 pb-8 px-8 bg-white">
                        <div className="flex items-center justify-between mb-1">
                            <label className="block text-sm font-medium text-gray-700">Profile Picture</label>
                            <button type="button" className="text-xs text-primary-600">Change Picture</button>
                        </div>
                        <div className="flex items-center p-4 border rounded-lg">
                            <img src="https://storage.googleapis.com/uxpilot-auth.appspot.com/avatars/avatar-3.jpg" alt="User" className="w-16 h-16 rounded-full mr-4" />
                            <div>
                                <p className="text-sm text-gray-600">john_smith_profile.jpg</p>
                                <p className="text-xs text-gray-500">Uploaded on Jun 1, 2023</p>
                            </div>
                        </div>
                    <div className="mb-6 mt-6">
                        <h4 className="text-sm font-medium text-gray-700 mb-3">Permissions</h4>
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
                            <label className="flex items-center p-3 border rounded-lg">
                                <input type="checkbox" checked="" className="rounded text-primary-600 mr-3" />
                                <div>
                                    <span className="block text-sm font-medium">Product Management</span>
                                    <span className="text-xs text-gray-500">Can add, edit, delete products</span>
                                </div>
                            </label>
                            <label className="flex items-center p-3 border rounded-lg">
                                <input type="checkbox" checked="" className="rounded text-primary-600 mr-3" />
                                <div>
                                    <span className="block text-sm font-medium">User Management</span>
                                    <span className="text-xs text-gray-500">Can manage other users</span>
                                </div>
                            </label>
                            <label className="flex items-center p-3 border rounded-lg">
                                <input type="checkbox" checked="" className="rounded text-primary-600 mr-3" />
                                <div>
                                    <span className="block text-sm font-medium">Order Processing</span>
                                    <span className="text-xs text-gray-500">Can process and manage orders</span>
                                </div>
                            </label>
                            <label className="flex items-center p-3 border rounded-lg">
                                <input type="checkbox" checked="" className="rounded text-primary-600 mr-3" />
                                <div>
                                    <span className="block text-sm font-medium">Financial Reports</span>
                                    <span className="text-xs text-gray-500">Can view and export financial data</span>
                                </div>
                            </label>
                        </div>
                    </div>
                    <div className="mb-6">
                        <h4 className="text-sm font-medium text-gray-700 mb-3">Account Activity</h4>
                        <div className="bg-gray-50 rounded-lg p-4">
                            <div className="flex items-center justify-between mb-2">
                                <span className="text-sm text-gray-600">Last Login</span>
                                <span className="text-sm">Today, 09:45 AM</span>
                            </div>
                            <div className="flex items-center justify-between mb-2">
                                <span className="text-sm text-gray-600">Account Created</span>
                                <span className="text-sm">Jan 15, 2023</span>
                            </div>
                            <div className="flex items-center justify-between">
                                <span className="text-sm text-gray-600">Password Last Changed</span>
                                <span className="text-sm">May 20, 2023</span>
                            </div>
                        </div>
                    </div>
                      <div className="border-t pt-4 flex justify-end space-x-3">
                           <Link to="/users" class="px-4 py-2 border border-gray-300 rounded-lg text-gray-700" id="cancel-category-modal">Cancel</Link>
                          <button type="submit" className="px-4 py-2 bg-primary-600 text-white rounded-lg">Submit</button>
                      </div>
                       </div>
                      </form>
                      </main>
      </div>
  )
}
